<ifc-base-dialog [title]="data.title"
                 [actions]="actions"
                 (actionClicked)="onActionClicked()">
  <ng-template #content>
    <p class="secondary-text">
      <span *ngIf="!data.bankIntegrationRequired">
        Thank you for your {{data.action}} in the amount of {{data.transferInfo?.amountInput | currency:'$'}}.
        Your request will be processed within 1-2 business days.
      </span>
      <span *ngIf="data.bankIntegrationRequired">
        Thank you for your {{data.action}} in the amount of {{data.transferInfo?.amountInput | currency:'$'}}.
        Link your bank to speed up the funding process.
        Your request will be processed within 1-2 business days.
      </span>
    </p>

    <mat-card appearance="outlined">
      <mat-card-content class="card-content">
        <ifc-horizontal-list [items]="items"></ifc-horizontal-list>
      </mat-card-content>
    </mat-card>

    <div *ngIf="!data.transferInfo.drawHidden && data.transferInfo?.balanceAfter?.availableBalance >= data.transferInfo?.amountMinimum">
      <p class="secondary-text">
        See your new available funds below and draw again at any time. Just return to your dashboard, click on DRAW and
        choose your desired amount.
      </p>
      <div fxLayout="column"
           fxFlexAlign="center center"
           class="available-funds">
        <div class="amount">{{data.transferInfo?.balanceAfter?.availableBalance | currency:'$'}}</div>
        <div class="mat-caption">Available funds</div>
      </div>
    </div>
  </ng-template>
</ifc-base-dialog>
